import React from 'react';
import Event from "../Event";
import Url from "../Url";
import { Tooltip } from 'reactstrap';

export default class ProfileReducedCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            tooltip: {
                singlemessage: false,
                profileRequest: false,
                cv: false,
                voicereel: false
            },
            profileRequestLoading: false,
            completionRequested: false
        };
    }

    coverLetter(e) {
        e.preventDefault();
        Event.fire('contentModal.show', {
            title: 'Cover Letter',
            content: this.props.user.formattedCoverLetter ? this.props.user.formattedCoverLetter : this.props.user.coverletter,
            type: this.props.user.formattedCoverLetter ? 'html' : 'text'
        });
    }

    tooltipToggle(name) {
        let tooltip = this.state.tooltip;
        tooltip[name] = !this.state.tooltip[name];
        this.setState({ tooltip });
    }

    fileDownloadLink(file) {
        return `${window.baseURI}/file-download/${file.uid}` + ([2, 3].indexOf(file.parenttype) !== -1 ? '/go' : '');
    }

    render() {
        return (
            <div className="card rounded mb-4 logCard" data-user-uid-log={this.props.user.uid}>
                <div className="card-img-container">
                    <img className="card-img-top img-fluid" loading="lazy" src={this.props.user.picture.approved ? this.props.imageUrl : Url.image()} alt={`${this.props.user.firstname} ${this.props.user.lastname}`} />
                    {!this.props.user.picture.approved ? <p className="small mb-2" style={{
                        position: 'absolute',
                        top: '20px',
                        left: 0,
                        right: 0
                    }}>*Image pending approval.</p> : null}
                </div>
                <div className="card-body">
                    <h5 className="card-title one-line-ellipsis">
                        {this.props.user.candidateLink ? <a target="_blank" href={this.props.user.candidateLink}>{`${this.props.user.firstname} ${this.props.user.lastname}`}</a> : `${this.props.user.firstname} ${this.props.user.lastname}`}
                    </h5>
                    <div className="text-center usr-actions no-print">
                        <a id={`singleMessage_tooltip_${this.props.user.uid}_ProfileCard`} href={!this.props.user.user ? `mailto:${this.props.user.email}` : '#'} onClick={(e) => {
                            if (this.props.user.user) {
                                e.preventDefault();
                                Event.fire('singleMessageModal.show', this.props.user.user);
                            }
                        }} target="_blank"><i className="far fa-envelope-open" aria-hidden="true"></i></a>
                        {this.props.user.cv ? <a id={`cv_tooltip_${this.props.user.uid}_ProfileCard`} href={this.fileDownloadLink(this.props.user.cv)}><i className="fa fa-file" aria-hidden="true"></i></a> : null}
                        {this.props.user.voicereel ? <a id={`voicereel_tooltip_${this.props.user.uid}_ProfileCard`} href={this.fileDownloadLink(this.props.user.voicereel)}><i className="fa fa-microphone" aria-hidden="true"></i></a> : null}
                        <Tooltip placement="bottom" isOpen={this.state.tooltip.singleMessage} target={`singleMessage_tooltip_${this.props.user.uid}_ProfileCard`} toggle={() => this.tooltipToggle('singleMessage')}>Message</Tooltip>
                        {this.props.user.cv ? <Tooltip placement="bottom" isOpen={this.state.tooltip.cv} target={`cv_tooltip_${this.props.user.uid}_ProfileCard`} toggle={() => this.tooltipToggle('cv')}>Download CV</Tooltip> : null}
                        {this.props.user.voicereel ? <Tooltip placement="bottom" isOpen={this.state.tooltip.voicereel} target={`voicereel_tooltip_${this.props.user.uid}_ProfileCard`} toggle={() => this.tooltipToggle('voicereel')}>Download Voicereel</Tooltip> : null}
                    </div>
                    {window.loggedInUser && window.loggedInUser.type === 2 && this.props.user.coverletter ? (
                        <div className="coverletter-wrapper">
                            <p className="secondary small intro">{this.props.user.coverletter.substr(0, 200)}
                                {this.props.user.coverletter.length > 200 ? (
                                    <a href="#" onClick={(e) => this.coverLetter(e)}>... read more</a>
                                ) : null}
                            </p>
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }
}